import styled from 'styled-components'

const FAQStyle = styled.div.attrs({})`
    .top-section {
        background-image: url('/images/faq.webp');
        background-size: cover;
        width: 100%;
        /* height: 400px; */
        height:300px;
        border-radius:20px;
        position: relative;

        .content {
            max-width:var(--sp122x);
            padding:0 var(--sp8x);
            width: 100%;

            .comp-title {
                /* margin-bottom:var(--sp4x); */
                align-self: center;
            }

            .search-cont {
                position: relative;

                i {
                    position: absolute;
                    top:50%;
                    left:var(--sp2x);
                    transform:translateY(-50%);
                    font-size: var(--sp2-5x);
                    z-index: 1;
                }

                .ant-form-item {
                    margin: 0;

                    .input-text {
                        background-color:var(--white);
                        padding-left: var(--sp6x);
                    }
                }
            }
        }
    }

    .popular {
        max-width:var(--sp122x);
        width: 100%;
        padding:0 var(--sp8x);
        margin-left: auto;
        margin-right: auto;
        margin-top:var(--sp9x);
        
        .section {
            a {
                padding:var(--sp4x);
                width: calc(50% - var(--sp2x));
                margin-top:var(--sp4x);
                background-color: var(--lightYellow);
                border-radius:10px;
                
                &:nth-child(2n) {
                    margin-left:var(--sp2x);
                }
                
                &:nth-child(2n-1) {
                    margin-right:var(--sp2x);
                }
                
                i {
                    transform:rotate(90deg);
                }
            }
        }
    }
    
    .asked {
        max-width:var(--sp122x);
        width: 100%;
        padding:0 var(--sp8x);
        margin-left: auto;
        margin-right: auto;
        margin-top:var(--sp9x);
        margin-bottom:var(--sp10x);

        .ant-collapse {
            margin-top:var(--sp4x);
            border:none;
            background: none;

            .ant-collapse-item {
                border:none;
                background-color: var(--white);
                border:1px solid #f1f1f1;
                border-radius: 10px;
                margin-bottom: var(--sp2x);

                &.ant-collapse-item-active {
                    .ant-collapse-header .anticon {
                        transform: rotate(180deg);
                    }
                }
                
                .ant-collapse-header {
                    padding:var(--sp4x);
                    display: flex;
                    align-items:center;
                    flex-direction: row-reverse;
                    justify-content: space-between;
                    
                    &:before,
                    &:after {
                        display: none;
                    }
                    
                    .anticon {
                        transform: rotate(90deg);
                        margin-right: 0;
                    }
                }

                .ant-collapse-content {
                    border:none;

                    .ant-collapse-content-box {
                        padding:0 var(--sp4x) var(--sp4x);
                    }
                }
            }
        }
    }

    @media screen and (max-width:${(props) => props.theme.mediaQuery.TabletSizeS}){
        .top-section {
            /* height: 428px; */
            height:150px ;
            background-position: right;

            .content {
                max-width:unset;
                padding:0 var(--sp2x);
                
                .comp-title {
                    /* margin-bottom:var(--sp3x); */
                    text-align: center;
                    width: 96%;
                }

                .search-cont {
                    i {
                        left:var(--sp2x);
                        font-size: var(--sp2-5x);
                        z-index: 1;
                    }

                    .ant-form-item {
                        margin: 0;

                        .input-text {
                            background-color:var(--white);
                            padding-left: var(--sp6x);
                        }
                    }
                }
            }
        }

        .popular {
            max-width:unset;
            width: 100%;
            padding:0 var(--sp2x);
            margin-top:var(--sp6x);

            .section {
                flex-direction: column;

                a {
                    width: 100%;
                    padding:var(--sp2-5x) var(--sp2x);
                    margin-top:var(--sp4x);
                    
                    &:nth-child(2n) {
                        margin-left:0;
                    }
                    
                    &:nth-child(2n-1) {
                        margin-right:0;
                    }
                    
                }
            }
        }
        
        .asked {
            max-width:unset;
            width: 100%;
            padding:0 var(--sp2x);
            margin-top:var(--sp4x);
            margin-bottom:var(--sp10x);

            .ant-collapse {
                margin-top:var(--sp4x);

                .ant-collapse-item {
                    margin-bottom: var(--sp2x);
                    width: 100%;

                    .ant-collapse-header {
                        padding:var(--sp3x) var(--sp2x);
                    }
                    
                    .ant-collapse-content {
                        border:none;
                        
                        padding:0  var(--sp2x) var(--sp4x);

                        .ant-collapse-content-box {
                            padding:0;
                        }
                    }
                }
            }
        }
    }
`
export default FAQStyle
